import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";
import { tutorAuthActions } from "_actions";
import { history } from '_helpers/history'
import { Table, Tag, Space } from 'antd';

function Validatetutor(props) {



    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    var tutorList = useSelector((state) => state.authReducer.tutorInformationList);
    var tutorListError = useSelector((state) => state.authReducer.tutorInformationListError);
    var columns = null;
    var data = null;
    const [tutorInformationList, setTutorInformationList] = useState(null);
    const [tutorInformationListError, setTutorInformationListError] = useState(null);

    const validarTutor = ((id) => {
      dispatch(tutorAuthActions.activateTutorById(id));
    });


    function generateColumns(data) {
      var columns = [];
      Object.keys(data).forEach((key) => {
        if( key=="email" || key=="name" || key=="surname"){
          var column = 
          {
            title: key.charAt(0).toUpperCase() + key.slice(1),

            dataIndex: key,
            key: key,
            render: key => <a>{key}</a>,
          }
          
          columns.push(column);
        }
      })
      var action = {
        title: 'Validar',
        key: 'validar',
        render: (text, record) => (
          <Space size="middle">
            <a onClick={() => validarTutor(record.id)}>Validar a {record.name}</a>

          </Space>
        ),
      }
      columns.push(action);
      return columns;
    }
  
    
    function generateData (data, columns) {

      if(columns!=null && columns != undefined){
        var dataValues = [];
        var dataEntry = {}
        data.map((row) => {
          dataEntry = {}

          if(row["validated"] == false){ 
            dataValues.push(row);
          }
        })
      return dataValues;
    }
  }

    useEffect(() => {
        dispatch(tutorAuthActions.getTutors());
    },[]);

    useEffect(() => {
       if(tutorList != undefined && tutorList != null & tutorList.length>0){
        var columns = generateColumns(tutorList[0]);
        if(columns!=undefined && columns != null){
        var data= generateData(tutorList, columns);
        }
       }
      var antdTable = {}
      antdTable["columns"] = columns;
      antdTable["data"] = data;
       setTutorInformationList(antdTable);
    }, [tutorList]);

    useEffect(() => {
      setTutorInformationListError(tutorListError);
  }, [tutorListError]);
  
    useEffect(() => {
        setTutorInformationListError(tutorListError);
    }, [tutorListError]);




return (
<div>



  {(tutorInformationList != null && 
    tutorInformationList != undefined) &&
    <Table columns={tutorInformationList["columns"]} dataSource={tutorInformationList["data"]} />
  }


</div>
)
}
export default withTranslation()(Validatetutor);
